import React from 'react'

const UserContactInfo = props => {
  return (
    <div className="island group-contact-info">
      <h2>Contact Information</h2>

      <div className="field field-name-field-donor-first-name field-type-text field-label-above">
        <div className="field-label">First Name:&nbsp;</div>
        <div className="field-items">
          <div className="field-item even">{props.user.given_name}</div>
        </div>
      </div>

      <div className="field field-name-field-donor-last-name field-type-text field-label-above">
        <div className="field-label">Last Name:&nbsp;</div>
        <div className="field-items">
          <div className="field-item even">{props.user.family_name}</div>
        </div>
      </div>

      <div className="field field-name-field-country-code-phone field-type-list-text field-label-above">
        <div className="field-label">Country Code:&nbsp;</div>
        {/* <div className="field-items">
          <div className="field-item even">63</div>
        </div> */}
      </div>
    </div>
  )
}

export default UserContactInfo
